import React from "react";
import styles from "./icon.module.scss"; // Import css modules stylesheet as styles

export function getIcon(iconName, customStyles, onError, onClick, customIcon) {
    const additionalClasses = (customStyles) ? customStyles : "";

    var icon = customIcon;
    if (icon == null) {
        icon = require(`../media/images/icons/line/dark/${iconName}`);
    }

    return <img className={styles.icon + " " + additionalClasses} src={icon} onError={onError} onClick={onClick}/>;
}